import { useGameStore } from '../../store/gameSlice';
import { INTERFACE_REGISTRY } from './interfaces.config';
import { UnknownInterfaceScreen } from './UnknownInterfaceScreen';

/**
 * Renders the active interface as a global overlay — mounted unconditionally in
 * `App.tsx`, so it sits over whatever gameplay state is active (hub or dungeon).
 * An unregistered id renders UnknownInterfaceScreen so the game can always be
 * unfrozen. Full-screen states (main menu, dungeon-map) are separate, gated by
 * `gameplay`.
 */
export const InterfaceManager = () => {
  const activeInterface = useGameStore((s) => s.activeInterface);

  if (!activeInterface) {
    return null;
  }

  const Component = INTERFACE_REGISTRY[activeInterface];
  if (!Component) {
    return <UnknownInterfaceScreen id={activeInterface} />;
  }

  return <Component />;
};
